function initIndexMobileFeatureCollectionSlider() {
  const collectionTabs = document.querySelectorAll(".index_mobile_feature_collection_slider_item");

  if (window.innerWidth >= 750) {
    collectionTabs.forEach((tab) => tab.classList.remove("active"));
    return;
  }

  collectionTabs.forEach((collectionTab, index) => {
    if (collectionTab.dataset.sliderInitialized === "true") return;

    collectionTab.addEventListener("click", function () {
      collectionTabs.forEach((tab) => tab.classList.remove("active"));
      this.classList.add("active");

      if (index !== 0) {
        this.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest"
        });
      }
    });

    collectionTab.dataset.sliderInitialized = "true";
  });

  const firstTab = document.querySelector(".index_mobile_feature_collection_slider_item:first-child");
  if (firstTab && !document.querySelector(".index_mobile_feature_collection_slider_item.active")) {
    firstTab.classList.add("active");
  }
}

initIndexMobileFeatureCollectionSlider();
window.addEventListener("resize", initIndexMobileFeatureCollectionSlider);
